import React, { FC, useEffect, useState, useCallback } from 'react';
import Header from 'components/header/Header.container';
import Footer from 'components/footer/Footer';
import { User } from 'modules/user/types';
import Styles from 'views/chatScreen/ChatScreen.module.scss';
import ChatRoomPanel from 'components/chatRoomPanel/ChatRoomPanel';
import ArticlesAdminRow from 'views/chatScreen/articlesAdminRow/ArticlesAdminRow';
import NewsAggregator from 'views/chatScreen/newsAggregator/NewsAggregator';
import WelcomeModal from 'views/chatScreen/welcomeModal/WelcomeModal';

interface StartScreenProps {
  user: User;
}

const ChatScreen: FC<StartScreenProps> = () => {
  const [showWelcome, setShowWelcome] = useState(false);
  const [welcomeName, setWelcomeName] = useState('');
  const [createRoomPopup, setCreateRoomPopup] = useState(false);

  // One-time welcome modal: shown immediately after signup (flag set in
  // StepFour), then the flag is cleared so it never appears again.
  useEffect(() => {
    if (localStorage.getItem('mp_welcome_pending') === '1') {
      setWelcomeName(localStorage.getItem('mp_welcome_name') || '');
      localStorage.removeItem('mp_welcome_pending');
      localStorage.removeItem('mp_welcome_name');
      setShowWelcome(true);
    }
  }, []);

  const handleCreateRoom = useCallback(() => {
    setCreateRoomPopup(false);
    requestAnimationFrame(() => setCreateRoomPopup(true));
  }, []);

  return (
    <div className="appPageScroll">
      <Header showPopup={createRoomPopup} />
      <div className="custom-container">
        <div className={Styles.dashboardLayout}>
          <ArticlesAdminRow />

          <NewsAggregator />

          <ChatRoomPanel onCreateRoom={handleCreateRoom} />
        </div>
      </div>
      <Footer />
      {showWelcome && (
        <WelcomeModal name={welcomeName} onClose={() => setShowWelcome(false)} />
      )}
    </div>
  );
};

export default ChatScreen;
